import { HStack, Skeleton, SkeletonText, VStack } from "@chakra-ui/react";
import React from "react";
export const ResultSkeleton = () => {
    return (React.createElement(VStack, { spacing: 4, width: "100%" },
        React.createElement(Skeleton, { height: "3rem", width: "100%" }),
        React.createElement(HStack, { spacing: 4, width: "100%", justifyContent: "flex-start", alignItems: "flex-start" },
            React.createElement(Skeleton, { height: "6rem", width: "8rem" }),
            React.createElement(SkeletonText, { noOfLines: 3, skeletonHeight: 4, width: "100%" }))));
};
